<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　

    <div class="mypagebox">
      <div class="leftbox">
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMyinfo()">
            <p>我的信息</p>
          </a>
        </div>
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMyorder()">
            <p>我的订单</p>
          </a>
        </div>
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMytie()">
            <p>百万铁人</p>
          </a>
        </div>

        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMyrace()">
            <p>我的赛事</p>
          </a>
        </div>
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ExitPerson()">
            <p>退出账户</p>
          </a>
        </div>
      </div>
      <div class="rightbox">
        <div class="rightsubbox2" v-if="showtype == 1">
          <!-- <p>我的信息</p> -->
          <p v-if="userinfo.id && userinfo.id.length >= 2">
            用户ID：{{ userinfo.id }}
          </p>
          <p v-if="userinfo.nickName && userinfo.nickName.length >= 2">
            姓名：{{ userinfo.nickName }}
          </p>
          <p v-if="userinfo.userPhone && userinfo.userPhone.length >= 2">
            手机号：{{ userinfo.userPhone }}
          </p>

          <div v-if="userinfo.userGender && userinfo.userGender.length >= 2">
            <p v-if="userinfo.userGender == 'male'">性别：男</p>
            <p v-if="userinfo.userGender == 'female'">性别：女</p>
          </div>

          <!-- <p v-if="userinfo.birthday && userinfo.birthday.length >= 2">
            出生日期：{{ userinfo.birthday }}
          </p>
          <p v-if="userinfo.countryName && userinfo.countryName.length >= 2">
            国籍/地区：{{ userinfo.countryName }}
          </p>
          <p v-if="userinfo.clubName && userinfo.clubName.length >= 2">
            所属俱乐部：{{ userinfo.clubName }}
          </p>
          <p v-if="userinfo.documentType && userinfo.documentType.length >= 2">
            证件类型：{{
              userinfo.documentType == "id_card" ? "身份证" : "护照"
            }}
          </p>
          <p
            v-if="
              userinfo.documentNumber && userinfo.documentNumber.length >= 2
            "
          >
            证件号码：{{ userinfo.documentNumber }}
          </p> -->
        </div>

        <div class="rightsubbox" v-if="showtype == 2">
          <p class="rightsubboxtitle">我的订单</p>
          <div class="orderbox" v-for="item in orderlist" :key="item.id">
            <a href="javascript:void(0)" @click="gotoOrderdes(item.id)">
              <div class="orderItemTop">
                <p style="flex: 1; text-align: left">订单编号：{{ item.id }}</p>
                <p style="flex: 1; text-align: center">
                  订单时间：{{ item.createTime }}
                </p>
              </div>
              <div class="orderItemTop">
                <p style="flex: 2; text-align: left">
                  收货地址：{{ item.address }}
                </p>
              </div>

              <div class="orderItemMid" v-for="item2 in item.orderGoods" :key="item2.id">
                <div class="orderleftbox" style="flex: 1; text-align: left">
                  <div class="orderimg">
                    <img :src="item2.prodImage" alt="" />
                    <!-- <img src="~assets/images/race/raceitem2.jpg" alt="" /> -->
                  </div>
                </div>

                <div class="orderItemMidmid" style="flex: 5; text-align: center">
                  <p>{{ item2.prodName }}</p>
                </div>
                <div class="orderleftbox" style="flex: 2; text-align: right">
                  <p>单价：{{ item2.payAmount }}元 </p>
                </div>
              </div>



              <div class="orderItemBottom">
                <p style="flex: 3; text-align: center" v-if="item.status == 'WaitPay'">
                  订单状态：等待支付
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'PaySuccess'">
                  订单状态：已付款
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'Shipped'">
                  订单状态：已发货
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'Success'">
                  订单状态：已完成
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'Cancel'">
                  订单状态：已取消
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'InRefundGoods'">
                  订单状态：退货中
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'RefundGoodsSuccess'">
                  订单状态：退货成功
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'InRefundMoney'">
                  订单状态：退款中
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'RefundMoneySuccess'">
                  订单状态：退款成功
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'Refund'">
                  订单状态：退款退货中
                </p>
                <p style="flex: 3; text-align: center" v-if="item.status == 'RefundFail'">
                  订单状态：退款失败
                </p>
                <p style="flex: 1; text-align: center" v-if="item.status == 'WaitPay'" class="paybtn">
                  <a href="javascript:void(0)" @click="handlepaybtn(item.id)">付款</a>
                </p>
                <p style="flex: 1; text-align: center" v-if="item.status != 'WaitPay'"></p>
                <p style="flex: 3; text-align: right">
                  总价：{{ item.orderAmount }}元
                </p>
              </div>
            </a>
          </div>
        </div>

        <div class="rightsubbox2" v-if="showtype == 3">

          <div class="tierenbox" v-if="userinfo.status == 'new_user'">
            <p>百万铁人注册信息</p>
            <p class="tierenboxstatus">未注册</p>
          </div>

          <div class="tierenbox" v-if="userinfo.status != 'new_user'">
            <p>百万铁人注册信息</p>
            <p class="tierenboxstatus">
              {{ userinfo.status == 'awaiting_review' ? '待审核' : userinfo.status == 'fail_review' ? '审核失败' : '认证铁人' }}
            </p>
            <p v-if="userinfo.nickName && userinfo.nickName.length >= 2">
              姓名：{{ userinfo.nickName }}
            </p>
            <p v-if="userinfo.userPhone && userinfo.userPhone.length >= 2">
              手机号：{{ userinfo.userPhone }}
            </p>

            <div v-if="userinfo.userGender && userinfo.userGender.length >= 2">
              <p v-if="userinfo.userGender == 'male'">性别：男</p>
              <p v-if="userinfo.userGender == 'female'">性别：女</p>
            </div>

            <p v-if="userinfo.birthday && userinfo.birthday.length >= 2">
              出生日期：{{ userinfo.birthday }}
            </p>
            <p v-if="userinfo.countryName && userinfo.countryName.length >= 2">
              国籍/地区：{{ userinfo.countryName }}
            </p>
            <p v-if="userinfo.clubName && userinfo.clubName.length >= 2">
              所属俱乐部：{{ userinfo.clubName }}
            </p>
            <p v-if="userinfo.documentType && userinfo.documentType.length >= 2">
              证件类型：{{
                userinfo.documentType == "id_card" ? "身份证" : "护照"
              }}
            </p>
            <p v-if="
              userinfo.documentNumber && userinfo.documentNumber.length >= 2
            ">
              证件号码：{{ userinfo.documentNumber }}
            </p>
          </div>
        </div>

        <div class="rightsubbox" v-if="showtype == 4">
          <p>我的课程</p>
        </div>


        <div class="rightsubbox" v-if="showtype == 5">
          <p>我报名的赛事</p>
          <div class="orderbox" v-for="item in racelist" :key="item.id">
            <a href="javascript:void(0)">
              <div class="orderItemTop">
                <p style="flex: 1; text-align: left">订单编号：{{ item.id }}</p>
                <p style="flex: 1; text-align: center">
                  订单时间：{{ item.createTime }}
                </p>
              </div>
              <div class="orderItemTop">
                <p style="flex: 2; text-align: left">
                  收货地址：{{ item.address }}
                </p>
              </div>
              <div class="orderItemMid">
                <div class="orderleftbox" style="flex: 1; text-align: left">
                  <div class="orderimg">
                    <img src="~assets/images/race/raceitem2.jpg" alt="" />
                  </div>
                </div>

                <div class="orderItemMidmid" style="flex: 5; text-align: center">
                  <p>{{ item.orderTitle }}</p>
                </div>
                <div class="orderleftbox" style="flex: 2; text-align: right">
                  <p>单价：{{ item.payAmount }}元 数量：1</p>
                </div>
              </div>

              <div class="orderItemBottom">
                <!-- <p
                  style="flex: 1; text-align: center"
                  v-if="item.status != 'WaitPay'"
                ></p>
                <p style="flex: 3; text-align: right">
                  总价：{{ item.orderAmount }}元
                </p> -->
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios

export default {
  name: "Myselfpage",
  data() {
    return {
      showtype: 1,
      msg: "",
      token: "",
      response: null,
      error: null,
      userinfo: {},
      orderlist: [],
      racelist: [],
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {},
  methods: {
    ShowMyinfo: function () {
      this.showtype = 1;
    },
    ShowMyorder: function () {
      this.showtype = 2;
      this.GetShopListPostRequest();
    },
    ShowMytie: function () {
      this.showtype = 3;

    },
    ShowMycourse: function () {
      this.showtype = 4;
      this.GetCourseListPostRequest();
    },
    ShowMyrace: function () {
      this.showtype = 5;
      this.GetRaceListPostRequest();
    },
    ExitPerson: function () {
      localStorage.setItem("token", "");
      this.$router.push({
        name: "Index",
      });
    },
    gotoHomePage: function () {
      this.$router.push({
        name: "Index",
      });
    },
    gotoRegPage: function () {
      this.$router.push({
        name: "regPage",
      });
    },
    gotoOrderdes: function (id) {
      console.log("orderid=" + id);
    },

    async GetShopListPostRequest() {
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          page: 1,
          size: 20,
          orderType: "goods",
        };

        const url = " https://ttserver.aizhuotice.online/api/v1/order/page";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response);
        if (this.response.code == 200) {
          // this.userinfo = this.response.data;
          this.orderlist = this.response.data.data;
          console.log(this.response.data);
          console.log("goods 成功");
        } else {
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },

    async GetRaceListPostRequest() {
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          page: 1,
          size: 20,
          orderType: "race",
        };

        const url = " https://ttserver.aizhuotice.online/api/v1/order/page";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response);
        if (this.response.code == 200) {
          // this.userinfo = this.response.data;
          this.racelist = this.response.data.data;
          console.log(this.response.data);
          console.log("goods 成功");
        } else {
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },

    handlepaybtn: function (id) {
      console.log("handlepaybtn");
      this.sendpayPostRequest(id);
    },

    async sendpayPostRequest(id) {
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;

        const updata = {
          orderId: id,
        };

        // 配置 POST 请求的 URL 和数据
        const url = "https://ttserver.aizhuotice.online/api/v1/pay/order";
        // 发起 POST 请求
        const response = await axios.post(url, updata, {
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response);
        if (this.response.code == 200) {
          alert("支付成功");
          //刷新页面
          this.GetShopListPostRequest();
          // localStorage.setItem('token', this.response.data.token);
          //   this.gotoShoplist();
          //   this.showpay = true;
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
      } finally {
        // 无论成功或失败，都重新启用按钮
      }
    },

    CheckUserbtn: function () {
      this.CheckUserPostRequest();
    },
    async CheckUserPostRequest() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const url = " https://ttserver.aizhuotice.online/api/v1/userInfo";
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response);
        if (this.response.code == 200) {
          this.userinfo = this.response.data;
          console.log(this.userinfo);
          console.log("user 成功");
        }
        if (this.response.code == 401) {
          alert("未登陆");
          this.gotoRegPage();
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.CheckUserbtn();
  },
  created() { },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.mypagebox {
  width: 100vw;
  height: auto;
  position: relative;
  background-color: #181818;
}

.leftbox {
  position: relative;
  width: 10vw;
  height: 25vw;
  left: 5vw;
  background-color: #000;
  padding-top: 4vw;
}

.leftbox .mypageboxitem {
  width: 100%;
  height: 4vw;
  /* background-color: #111; */
}

.leftbox .mypageboxitem p {
  font-size: 1.5vw;
  color: #fff;
  line-height: 4vw;
  width: 100%;
  text-align: center;
}

.rightbox {
  position: relative;
  width: 85vw;
  height: auto;
  left: 15vw;
  top: -29vw;
  /* background-color: #000  ; */
}

.rightbox .mypageboxitem {
  width: 100%;
  height: 4vw;
  background-color: #111;
}

.rightbox .rightsubbox p {
  font-size: 1.5vw;
  color: #fff;
  width: 95%;
}

.rightsubboxtitle {
  line-height: 4vw;
  text-align: center;
}

.rightsubboxtitle {
  font-size: 2vw;
  font-weight: bold;
  border-bottom: 4px solid #a81f24;
  /* margin-bottom: 1vw; */
}

.orderbox {
  position: relative;
  padding-left: 3vw;
  width: 92%;
  height: auto;
  /* background-color: #111; */
  padding-bottom: 0.5vw;
  border-bottom: 2px solid #a81f24;
  padding-top: 0.5vw;
}

.orderItemTop {
  position: relative;
  width: 100%;
  height: 2vw;
  display: flex;
  font-size: 1.3vw;
}

.rightbox .orderbox .orderItemTop p {
  font-size: 1.3vw;
}

.orderItemMid {
  position: relative;
  height: 5vw;
  width: 97%;
  margin-top: 1.5vw;
  display: flex;
}

.orderItemMid .orderimg {
  position: relative;
  width: 5vw;
  height: 5vw;
}

.orderItemMid .orderimg img {
  position: relative;

  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 按比例缩放并裁剪 */
}

.rightbox .orderbox .orderItemBottom {
  position: relative;
  width: 98%;
  height: 2vw;
  display: flex;
  font-size: 1.5vw;
  margin-top: 0.5vw;
}

.rightbox .orderbox .orderItemMidmid p {
  font-size: 1.3vw;
  text-align: right;
  width: 100%;
  position: relative;
}

.rightbox .orderbox .orderItemBottom p {
  font-size: 1.3vw;
  position: relative;
}

.paybtn {
  background-color: #a81f24;
  color: #fff;
  width: 5vw;
  height: 1.5vw;
  text-align: center;
  line-height: 1.5vw;
  border-radius: 0.5vw;
}

.orderItemBottom a {
  color: #fff;
  text-decoration: none;
}

.rightbox .rightsubbox2 {
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 3vw;
  padding-top: 3vw;
}

.rightbox .rightsubbox2 p {
  font-size: 1.5vw;
  color: #fff;
  width: 100%;
}

.rightbox .rightsubbox2 .tierenboxstatus {
  font-size: 1.8vw;
  color: #a81f24;
  padding-top: 1vw;
  padding-bottom: 1vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Myselfpage.vue